import '@fontsource-variable/archivo';
import { createTheme } from '@mui/material/styles';
import { CaretDownIcon } from '@phosphor-icons/react';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0f3993',
      light: '#6c7fc0',
      dark: '#001e72',
    },
    secondary: {
      main: '#b3f2db',
      light: '#e0faf1',
      dark: '#43deaf',
    },
    error: {
      main: '#c9212e',
      light: '#f15056',
      dark: '#ba1223',
    },
    warning: {
      main: '#f7d146',
      light: '#fceab0',
      dark: '#f5bb00',
    },
    info: {
      main: '#bfc7e4',
      light: '#e6e9f4',
      dark: '#96a3d2',
    },
  },

  typography: {
    fontFamily: '"Archivo Variable", sans-serif',
    h1: {
      fontSize: '32px',
      fontWeight: 600,
    },
    h2: {
      fontSize: '24px',
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 0,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        slotProps: {
          select: {
            IconComponent: CaretDownIcon,
          },
        },
      },
    },

    MuiTypography: {
      defaultProps: {
        variant: 'body2',
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Archivo Variable", sans-serif',
        },
      },
    },
  },
});
